import { isNil } from 'lodash/fp';
import { useSelector } from 'app/lib/hooks';
import { selectQueryForPropQueryId } from 'app/store/snowflakeQueries';

export function Context({ queryId }) {
    const query = useSelector(selectQueryForPropQueryId, { queryId });

    if (isNil(query?.meta?.description)) {
        return null;
    }

    return <span>{query.meta.description}</span>;
}
